const CUSTOM_TRACKING_EVENTS = {
    READY: 'custom_ready_event',
    TRACK: 'custom_track_event'
}

/**
 * Sends a user behaviour custom tracking event with optional
 * event properties.
 * This doen't depend on the tracking system used, giving
 * a common standard structure for sending events and leave the system
 * integration to the main container.
 * @param {string} eventName - Name of event
 * @param {object} [eventProperties] - Additional event properties
 */
const trackUserBehaviourEvent = (eventName, eventProperties = {}) => {
    const event = new CustomEvent(CUSTOM_TRACKING_EVENTS.TRACK, {
        detail: {
            eventName,
            eventProperties
        }
    })
    window.dispatchEvent(event)
}

/**
 * Sends the event that tracking system (managed by container) is
 * loaded successfully.
 */
const trackingIsReady = () => {
    const event = new CustomEvent(CUSTOM_TRACKING_EVENTS.READY)
    window.dispatchEvent(event)
}

/**
 * @deprecated Please use trackUserBehaviourEvent(eventName, eventProperties)
 */
const trackEventWithMixPanel = trackUserBehaviourEvent

/**
 * Google Analytics tracking will end on 31.08.2023.
 * This function will call trackUserBehaviourEvent and track the event
 * with the new analytics tool Mixpanel.
 * @deprecated Please use trackUserBehaviourEvent(eventName, eventProperties)
 */
const gtmHandleDataLayer = trackUserBehaviourEvent

export { CUSTOM_TRACKING_EVENTS, gtmHandleDataLayer, trackEventWithMixPanel, trackingIsReady, trackUserBehaviourEvent }
